var path = 'pages/circles.html';
var html = "<ui-view name=list data-ng-if=!mobile></ui-view> <ui-view></ui-view> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/pages/circles.html
// module id = rMRH
// module chunks = 1